(ns manage.external-templates-page.view
  (:require ["react-use/lib/useEvent$default" :as useEvent]
            [common.widgets.iframe.view :refer [iframe]]
            [re-frame.core :as rf]
            [uix.core :as uix]))

(defn handle-message [m]
  (rf/dispatch [:page.external-templates/handle-message m]))

(defn external-template-page []
  (uix/use-effect (fn []
                    (rf/dispatch [:page.external-templates/init]))
                  [])
  (useEvent "message" handle-message)
  (let [{:keys [url width height]} @(rf/subscribe [:context])
        cfn @(rf/subscribe [:page.external-templates/cfn])]
    (when cfn
      [:div
       {:style {:background-color "white"
                :width "100%"
                :height (if height (str height "px") "100%")}}
       [iframe
        {:id 1
         :src (when url (str url "?_lemonpiPreview"))
         :on-ready #(rf/dispatch [:page.external-templates/evaluate-cfn])
         :width (int width)
         :height (int height)
         :style {:border "none"}}]])))

